<template>
    <div>
        <v-container  fluid grid-list-md>
                <v-layout row wrap>

                    <v-flex xs12 sm12 md12>
                        <v-card>
                            <v-toolbar  
                                :height="50" >
                                <v-toolbar-title>Tolerancia</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn v-if="puedeAjustarTolerancia" icon class="hidden-xs-only" @click="toleranciaDialog()">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-container  fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md4>
                                        <h3>Entrada:</h3>
                                        <p>Previo: {{horario.tolerancia.entrada.previo}} minutos.</p>
                                        <p>Posterior: {{horario.tolerancia.entrada.posterior}} minutos.</p>
                                        <p>Retardo: {{horario.tolerancia.entrada.retardo}} minutos.</p>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <h3>Salida:</h3>
                                        <p>Previo: {{horario.tolerancia.salida.previo}} minutos.</p>
                                        <p>Posterior: {{horario.tolerancia.salida.posterior}} minutos.</p>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex v-for="(dia,index) in dias" :key="index"
                        xs6 sm4 md3>
                        <v-card>
                            <v-toolbar 
                                :height="50" >
                                <v-toolbar-title>{{dia.text}}</v-toolbar-title>
                            </v-toolbar>
                            <!-- <v-toolbar 
                                :color="horario[dia.key].length % 2 === 0 ? cardColor : cardError" 
                                :dark="horario[dia.key].length % 2 !== 0"
                                :height="50" >
                                <v-toolbar-title>{{dia.text}}</v-toolbar-title>
                            </v-toolbar> -->

                            <v-list>
                                <v-list-tile v-for="(horarioDia,index2) in horario[dia.key]" :key="horarioDia.hora">
                                    <v-list-tile-action>
                                        <i v-if="horarioDia.entrada" class="fa fa-sign-in-alt green--text mr-2 fs-14"></i>
                                        <i v-else class="fa fa-sign-out-alt red--text mr-2 fs-14"></i>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{horarioDia.hora}}</v-list-tile-title>
                                    </v-list-tile-content>
                                    
                                    <v-list-tile-action v-if="index2 === horario[dia.key].length-1 && puedeModificarHorario">
                                        <v-tooltip top>
                                            <v-btn slot="activator" icon ripple @click="eliminarHorario(horarioDia._id, dia.key)">
                                                <v-icon color="grey lighten-1">cancel</v-icon>
                                            </v-btn>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                            <v-card-text v-if="puedeModificarHorario" style="height: 50px; position: relative">
                                <v-btn absolute dark fab middle right color="blue" icon small flat
                                    @click="agregarDialog(dia.key,dia.text)">
                                <v-icon>add</v-icon>
                                </v-btn>
                            </v-card-text>
                            
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-container>

            <!-- AGREGAR HORARIO -->
            <v-dialog
                v-model="agregar.mostrar"
                width="500"
                >
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title> Agregar hora </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md text-xs-center>
                            <v-layout row wrap>
                                <v-flex xs4 sm4 md4>
                                    <v-text-field
                                        v-model="agregar.diaText"
                                        label="Día"
                                        readonly
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4 sm4 md4>
                                    <v-select 
                                        v-model="agregar.entrada"
                                        :items="[{text:'Entrada',value:true},{text:'Salida',value:false}]"
                                    />
                                    <!-- <v-text-field
                                        v-model="agregar.entradaLbl"
                                        readonly
                                    ></v-text-field> -->
                                </v-flex>
                                <v-flex xs4 sm4 md4>
                                    
                                    <v-menu
                                        ref="menu"
                                        v-model="agregar.horaPicker"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="agregar.horaPicker"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="agregar.hora"
                                            label="Seleccione hora"
                                            prepend-icon="access_time"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="agregar.horaPicker"
                                            v-model="agregar.hora"
                                            format="24hr"
                                            :min="agregar.min"
                                            full-width
                                            @click:minute="$refs.menu.save(agregar.hora)"
                                        ></v-time-picker>
                                    </v-menu>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="agregar.mostrar = false" >Cancelar </v-btn>
                    <v-btn color="primary" @click="agregarHora()" >Agregar </v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

        <!-- MODIFICAR TOLERANCIA -->
            <v-dialog
                v-model="tolerancia.mostrar"
                width="400"
                >
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title> Ajustar tolerancia </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md text-xs-center>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <h2>Entrada</h2>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.entrada.previo"
                                    :items="toleranciaSelect"
                                    label="Previo"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.entrada.posterior"
                                    :items="toleranciaSelect"
                                    label="Posterior"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.entrada.retardo"
                                    :items="toleranciaSelect"
                                    label="Retardo"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <h2>Salida</h2>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.salida.previo"
                                    :items="toleranciaSelect"
                                    label="Previo"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select
                                    v-model="tolerancia.salida.posterior"
                                    :items="toleranciaSelect"
                                    label="Posterior"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="tolerancia.mostrar = false" >Cancelar </v-btn>
                    <v-btn color="primary" @click="modificarTolerancia()" >Agregar </v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

        <!-- <asignaciones 
            :id="id"
            :dependencias="dependencias"
            :puestos="puestos"
            @dependenciaAgregada="dependenciaAgregada"
            @dependenciaEliminada="dependenciaEliminada"
            @puestoAgregado="puestoAgregado"
            @puestoEliminado="puestoEliminado"
            @enviandoStart="enviandoStart"
            @enviandoStop="enviandoStop"
        /> -->

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment'
import _ from 'underscore'

//import asignaciones from './asignaciones'

export default {
    name: 'HorarioPersonalizado',
    props: ['horario','id','dependencias','puestos'],
	components: {
        //asignaciones
	},
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "role",
            "permisos"
        ]),
        puedeModificarHorario(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 177) >= 0 
        },
        puedeAjustarTolerancia(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 178) >= 0 
        },
        toleranciaSelect(){
            let selector = []
            for( let i=0; i<=300; i+=5)
                selector.push({ value:i, text:i+' minutos' })
            return selector;
        }
    },
    data() {
        return {
            cardColor: 'grey lighten-2',
            cardError: 'red lighten-2',
            dias: [
                {key:'lunes', text:'Lunes'},
                {key:'martes', text:'Martes'},
                {key:'miercoles', text:'Miercoles'},
                {key:'jueves', text:'Jueves'},
                {key:'viernes', text:'Viernes'},
                {key:'sabado', text:'Sabado'},
                {key:'domingo', text:'Domingo'}
            ],
            agregar:{
                mostrar: false,
                dia: null,
                diaText: null,
                entrada: null,
                entradaLbl: null,
                hora: null,
                min: null,
                horaPicker: false
            },
            tolerancia:{
                mostrar: false,
                entrada: {
                    previo: 0,
                    posterior: 0,
                    retardo: 0
                },
                salida: {
                    previo: 0,
                    posterior: 0
                }
            }
        }
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        agregarDialog(dia,diaText){
            this.agregar.dia = dia;
            this.agregar.diaText = diaText;

            if(this.horario[dia].length === 0){
                this.agregar.entradaLbl = 'Entrada';
                this.agregar.hora = '08:00'
                this.agregar.min = null
                this.agregar.entrada = true;
            }
            else{
                let horario = this.horario[dia][this.horario[dia].length-1];
                let hora = moment();
                let ar = horario.hora.split(':');
                hora.set('hour',ar[0]);
                hora.set('minute',ar[1]);
                hora.hour(hora.hour()+1);
                this.agregar.min = hora.format('HH:mm');
                this.agregar.hora = hora.format('HH:mm');
                if(horario.entrada === true){
                    this.agregar.entrada = false
                    this.agregar.entradaLbl = 'Salida';
                }else{
                    this.agregar.entrada = true;
                    this.agregar.entradaLbl = 'Entrada';
                }
            }
            this.agregar.mostrar = true;
        },
        agregarHora(){
            this.enviandoStart();
            axios.post(this.httpURL+'/horarios/agregarHora/'+this.id,
                {hora:this.agregar.hora,dia:this.agregar.dia,entrada:this.agregar.entrada},
                {headers:{token: this.sessionToken}}
            )
            .then(res => {
                // console.log(res);
                // let personal = [];
                this.agregar.mostrar = false;
                this.$emit('horaAgregadaPersonalizado',this.agregar.dia,res.data.horario)
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        },
        eliminarHorario(idHora,dia){
            this.enviandoStart();
            axios.delete(this.httpURL+'/horarios/eliminarHora/'+this.id,
                {   
                    data: {idHora,dia},
                    headers:{token: this.sessionToken}
                }
            )
            .then(res => {
                // console.log(res);
                // let personal = [];
                this.$emit('horaEliminadaPersonalizado',dia,idHora)
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        },
        toleranciaDialog(){
            this.tolerancia.entrada = _.clone(this.horario.tolerancia.entrada);
            this.tolerancia.salida = _.clone(this.horario.tolerancia.salida);
            this.tolerancia.mostrar = true;
        },
        modificarTolerancia(){
            this.enviandoStart();
            axios.put(this.httpURL+'/horarios/tolerancia/'+this.id,
                { 
                    entrada_prev:this.tolerancia.entrada.previo, 
                    entrada_pos:this.tolerancia.entrada.posterior, 
                    entrada_ret:this.tolerancia.entrada.retardo, 
                    salida_prev:this.tolerancia.salida.previo,
                    salida_pos:this.tolerancia.salida.posterior,
                },
                {headers:{token: this.sessionToken}}
            )
            .then(res => {
                // console.log(res);
                // let personal = [];
                this.tolerancia.mostrar = false;            
                this.$emit('toleranciaPersonalizada',this.tolerancia.entrada,this.tolerancia.salida)
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
        },
        dependenciaAgregada(payload){
            this.$emit('dependenciaAgregada',payload);
        },
        dependenciaEliminada(payload){
            this.$emit('dependenciaEliminada',payload);
        },
        puestoAgregado(payload){
            this.$emit('puestoAgregado',payload);
        },
        puestoEliminado(payload){
            this.$emit('puestoEliminado',payload);
        }
    }
    
}
</script>